import { Link } from "react-router-dom";

import styled from "@emotion/styled";

export const CardStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 317px;
  padding: ${p => p.theme.space[6]}px;

  border-radius: 20px;
  background-color: ${p => p.cardBackground};

  @media screen and (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    height: 418px;
  }
`;

export const Title = styled.h3`
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 16px;
  color: ${p => p.titleColor};
  @media screen and (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 24px;
  }
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: ${p => p.descriptionColor};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;

  @media screen and (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    -webkit-line-clamp: 8;
  }
`;

export const LinkStyled = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
  gap: ${({ theme }) => theme.space[2]}px;

  color: ${({ buttontext }) => buttontext};
  background-color: ${({ buttoncolor }) => buttoncolor};
  text-decoration: none;
  border-radius: ${({ theme }) => theme.radii.medium};

  transition: background-color 0.3s ease-in-out;

  :hover {
    background-color: ${({ buttonhover }) => buttonhover};
  }

  :active {
    background-color: ${({ buttonactive }) => buttonactive};
  }

  @media screen and (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    padding: 14px 0;
  }

  -webkit-tap-highlight-color: transparent;
`;

export const NavigateWrapper = styled.div`
  margin-top: auto;
`;
